module.exports = __webpack_public_path__ + "media/images/noticia04.2-ba586ee15a936587996deda3e80d68a1.jpg";